import $ from 'jquery';
import { AJAX_URL } from '../config';

$(function () {
  if ($('.poll-form').length) {
    const poll_id = $('.poll-form').data('poll-id');
    let poll_cookie = getCookie('vote-poll-' + poll_id);

    if (poll_cookie !== undefined) {
      hidePoll();
    }

    $('body').on('change', '.poll-form input', (event) => {
      const checkbox = $(event.currentTarget).closest('.checkbox');
      let numberOfChecked = $('.poll-form input:checked').length;
      let numberAllowed = $('.poll-form').data('allowed');

      if (numberOfChecked > numberAllowed) {
        $(event.target).prop('checked', false);
      }

      if (event.currentTarget.checked) {
        checkbox.addClass('checked');
      } else {
        checkbox.removeClass('checked');
      }
    });

    $('form.poll-form').on('submit', (event) => {
      event.preventDefault();
      const submit_button = $('form.poll-form button.submit--poll');
      submit_button.prop('disabled', true);
      const form = $(event.currentTarget);
      const poll_id = form.data('poll-id');

      $.ajax({
        type: 'POST',
        url: `${AJAX_URL}post_ajax_poll_submit`,
        data: {
          poll_id: poll_id,
          form_data: form.serializeArray()
        },
        dataType: 'json',
        encode: true,
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        success: (res) => {
          setCookie('vote-poll-' + poll_id, '1');
          hidePoll();
        },
        error: (res) => {
          submit_button.prop('disabled', false);
        }
      });
    });
  }
});

function setCookie(name, value, expireDays = 365) {
  const date = new Date();
  date.setTime(date.getTime() + expireDays * 24 * 60 * 60 * 1000);
  const expires = 'expires=' + date.toUTCString();
  document.cookie = name + '=' + value + ';' + expires + ';path=/';
}

function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
}

function hidePoll() {
  let output =
    '<div class="poll--success"><p>We have received your vote!</p><br/><span><a href="/register">Click here to join the Beef Loving Texans community.</span></div>';
  $('.poll--container').html(output);
}
